import { takeLatest, call, put } from 'redux-saga/effects';

import { getTemplatePreviewThumbnails } from 'api/TemplateIndexAPI';
import { fetchConciseVisitorCounts } from 'api/WorkflowsAPI';

import { addToRootSaga } from 'store';

import {
  fetchThumbnails,
  handleThumbnailFetchSuccess,
  handleThumbnailFetchFailure,
  fetchSendActivity,
  handleSendActivityFetchSuccess,
  handleSendActivityFetchFailure,
} from './actions';
import { REDUX_ACTION_TYPES } from './constants';
import { LegacyWorkflowVisitorCountData, WorkflowId, WorkflowNodeTemplateId } from './types';

export function* getTemplatePreviewThumbnailsSaga({
  templateIds,
}: ReturnType<typeof fetchThumbnails>) {
  try {
    const thumbnails: Record<WorkflowNodeTemplateId, string> = yield call(
      getTemplatePreviewThumbnails,
      templateIds,
    );
    yield put(handleThumbnailFetchSuccess(templateIds, thumbnails));
  } catch (e) {
    yield put(handleThumbnailFetchFailure(templateIds));
  }
}

export function* getWorkflowsSendActivitySaga({
  workflowIds,
}: ReturnType<typeof fetchSendActivity>) {
  try {
    const {
      visitorCount: sendActivityArray,
    }: {
      visitorCount: (LegacyWorkflowVisitorCountData & {
        workflowId: WorkflowId;
      })[];
    } = yield call(fetchConciseVisitorCounts as any, workflowIds);
    const sendActivity: Record<WorkflowId, LegacyWorkflowVisitorCountData> =
      sendActivityArray.reduce(
        (previousValue, { workflowId, ...dataForWorkflow }) => ({
          ...previousValue,
          [workflowId]: dataForWorkflow,
        }),
        {},
      );
    yield put(handleSendActivityFetchSuccess(workflowIds, sendActivity));
  } catch (e) {
    yield put(handleSendActivityFetchFailure(workflowIds));
  }
}

addToRootSaga([
  takeLatest(REDUX_ACTION_TYPES.THUMBNAILS_FETCH_REQUESTED, getTemplatePreviewThumbnailsSaga),
  takeLatest(REDUX_ACTION_TYPES.SEND_ACTIVITY_FETCH_REQUESTED, getWorkflowsSendActivitySaga),
]);
